import styled from 'styled-components'
import { Label as LabelBase } from 'components/form/field/s'
import { captionSmallCss } from 'components/typography/caption'

export const Wrapper = styled.div`
    margin-top: 8px;
    margin-bottom: 24px;
`

export const Label = styled(LabelBase)`
    margin-bottom: 8px;
`

export const Signatories = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 8px;

    margin-top: 8px;
`

export const Signatory = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Meta = styled.div`
    display: flex;
    flex-direction: column;

    span:first-of-type {
        line-height: 24px;
    }

    span:last-of-type:not(:only-of-type) {
        ${captionSmallCss}
        margin-bottom: 0;
    }
`